import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const HeroSection = () => {
  return (
    <div className="relative h-[30vh]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/Images/bg.jpg')" }}
      />
      <div className="absolute inset-0 bg-[#212529]/80" />

      <motion.div
        className="relative max-w-7xl mx-auto px-6 h-full flex flex-col items-center justify-center text-center"
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
      >
        <motion.h1
          variants={fadeUp}
          className="text-2xl md:text-4xl font-bold text-[#f8f9fa]"
        >
          Services
        </motion.h1>
        <motion.p
          variants={fadeUp}
          className="mt-2 text-xs md:text-sm text-[#dee2e6]"
        >
          <Link to="/" className="hover:text-[#adb5bd] transition">
            Home
          </Link>{" "}
          / <span className="text-[#f8f9fa]">Services</span>
        </motion.p>
      </motion.div>
    </div>
  );
};

export default HeroSection;